export enum TestIds {
    CONTACT_US_BUTTON = "CONTACT_US_BUTTON",
}
